/**
 * 预览容器
 * @author chenqunfeng
 * @since 17/11/06
 */

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import PreviewDialog from 'components/preview/dialog';
import { setTemplate, setTplCollectionStatus } from 'actions/tpls';

const mapStateToProps = state => {
  const { tpls, lotteryInfo, storeTabs } = state;

  return {
    tpls: tpls.byId,
    lotteryId: lotteryInfo.lotteryId,
    activeIndex: storeTabs.activeIndex,
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      setTemplate,
      setTplCollectionStatus,
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PreviewDialog);
